import { render, staticRenderFns } from "./AddEStock.vue?vue&type=template&id=31192205&scoped=true"
import script from "./AddEStock.vue?vue&type=script&lang=js"
export * from "./AddEStock.vue?vue&type=script&lang=js"
import style0 from "./AddEStock.vue?vue&type=style&index=0&id=31192205&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31192205",
  null
  
)

export default component.exports